import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormControl } from 'react-bootstrap'
import { GlgButton, GlgCheckbox } from 'SharedComponents'
import ClearFilters from '../filters/clear_filters'
import { Col} from 'react-flexbox-grid'
import { GlgLoadingSpinner } from 'SharedComponents'
import { GlgTooltip } from 'SharedComponents'

class LocationFilter extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      location: '',
      locationIsLoading: false,
      locationLoaded: !!this.props.currentLocation || !!this.props.value.coords.city,
      radius: this.props.value.radius || '200',
      open: false,
      updated: false,
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  componentDidUpdate() {
    if (this.props.value && this.props.value.coords.lat && !this.state.updated) {
      // this.setState({open: true})
      fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + this.props.value.coords.lat + ',' + this.props.value.coords.lng + '&key=' + process.env.GOOGLE_MAP_KEY)
        .then(response => response.json())
        .then((json) => {
          if (json.status === 'OK') {
            const resultAddressComponents = json.results[0].address_components.filter((component) => component.types.includes('locality'))
            this.setState({location: resultAddressComponents[0].long_name, updated: true, open: true})
          }
        })
    }
  }
  errorLocation(error) {
    if (error) {
      this.setState({locationIsLoading: false, locationLoaded: true})
    }
  }

  getLocation(location) {
    let currentLocation
    if (this.props.currentLocation) {
      currentLocation = this.props.currentLocation
      this.setState({location: currentLocation})
    } else if (!this.props.value.coords.lat) {
      fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + location.coords.latitude + ',' + location.coords.longitude + '&key=' + process.env.GOOGLE_MAP_KEY)
      .then(response => response.json())
      .then((json) => {
        if (json.status === 'OK') {
          const resultAddressComponents = json.results[0].address_components.filter((component) => component.types.includes('locality'))
          currentLocation = resultAddressComponents[0].long_name
          this.setState({location: currentLocation, locationIsLoading: false, locationLoaded: true})
          this.props.onChange('currentLocation', resultAddressComponents[0].long_name)
          // this.props.onChange('location', {coords: {lat: location.coords.latitude, lng: location.coords.longitude}, radius: this.state.radius})
        }
      })
    }
    
  }

  location(event) {
    this.setState({location: event.target.value})
  }

  radius(event) {
    this.setState({radius: event.target.value})
  }

  handleClick() {
    if (!this.state.locationLoaded) {
      this.setState({locationIsLoading: true})
    } else {
      const location = this.props.value.city || this.state.location || this.props.currentLocation 
      this.setState({location: location})
    }

    if (navigator.geolocation && !this.state.locationLoaded) {
      navigator.geolocation.getCurrentPosition(location => this.getLocation(location), error => this.errorLocation(error))
    }

    this.setState({open: !this.state.open})
    if (this.state.open) {
      this.props.onChange('location', {coords: {lat: '', lng: ''}, radius: ''})
    }
  }

  handleChange() {
    if (this.state.location) {
      fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + this.state.location + '&key=' + process.env.GOOGLE_MAP_KEY)
      .then(response => response.json())
      .then((json) => {
        if (json.status === 'OK') {
          const radius = this.props.metricUnits === 'Meters' ? parseInt(this.state.radius / 1.609) : this.state.radius
          this.props.onChange('location', {coords: json.results[0].geometry.location, radius: radius, city: this.state.location})
        }
      })
    } else {
      this.props.onChange('location', {coords: {lat: '', lng: ''}, radius: ''})
    }
  }

  render() {
    let locationAdvancedClass
    let locationClass
    let clearFiltersClass
    if (this.state.open) {
      locationAdvancedClass = 'inline-box'
      locationClass = 'border-right-location add-margin-right-20-xs'
      clearFiltersClass = 'add-margin-top-10-sm'
    } else {
      locationClass = 'add-margin-right-20'
      locationAdvancedClass = 'location-advanced-hidden'
      clearFiltersClass = ''
    }
    return <Col md={12}>{this.props.showLocationFilter && <div className="pull-left visible-radius-xs"><div className="inline-box location-filter"><GlgTooltip tooltip={ !window.I18n ? '' : window.I18n.t('customer_directories.filters.location_filter_tooltip') }><div className={locationClass + ' add-margin-top-10 location inline-box'} onClick={this.handleClick}>{ !window.I18n ? '' : window.I18n.t('customer_directories.filters.location_filter_title') }<div className="location-checkbox"><GlgCheckbox name="copy_options[]" value="copy_player_roster" checked={ this.state.open } onChange={ () => this.handleClick } className={'location-checkbox'}></GlgCheckbox></div></div></GlgTooltip></div></div>}<div className="pull-right visible-radius-xs"><ClearFilters onChange={ this.props.onChange }></ClearFilters></div><Col md={12}><div className="visible-radius-xs"><div className="text-center"><div className={locationAdvancedClass}><div className="radius-color add-margin-left-5 add-margin-top-10">{ !window.I18n ? '' : window.I18n.t('customer_directories.filters.location_filter.display_within') }</div></div><div className={locationAdvancedClass + ' location-container-xs'}><FormControl type="number" value={ this.state.radius } onChange={e => this.radius(e)} inputRef={ ref => { this.inputRef = ref } } className={'radius-input location-text-input'}></FormControl><div className="add-margin-top-10 radius-second">{this.props.metricUnits === 'Meters' ? !window.I18n ? '' : window.I18n.t('customer_directories.filters.location_filter.kilometers_of') : !window.I18n ? '' : window.I18n.t('customer_directories.filters.location_filter.miles_of') }</div><FormControl type="text" value={this.state.location} onChange={e => this.location(e)} inputRef={ ref => { this.inputRef = ref } } className={'location-input location-text-input'}></FormControl><div className="go-button-container"><GlgButton text={ !window.I18n ? '' : window.I18n.t('customer_directories.filters.location_filter.go') } onClick={ this.handleChange } color="gray" size="normal" className={'go-button'}></GlgButton></div></div></div></div></Col>{this.props.showLocationFilter && <div className="pull-left hidden-directories-xs"><div className="location-filter inline-box"><GlgTooltip tooltip={ !window.I18n ? '' : window.I18n.t('customer_directories.filters.location_filter_tooltip') }><div className={locationClass + ' add-margin-top-10 location inline-box'} onClick={this.handleClick}>{ !window.I18n ? '' : window.I18n.t('customer_directories.filters.location_filter_title') }<div className="location-checkbox"><GlgCheckbox name="copy_options[]" value="copy_player_roster" checked={ this.state.open } onChange={ () => this.handleClick }></GlgCheckbox></div></div></GlgTooltip><div className={locationAdvancedClass}><div className="add-margin-top-10 radius-first">{ !window.I18n ? '' : window.I18n.t('customer_directories.filters.location_filter.display_within') }</div><FormControl type="number" value={ this.state.radius } onChange={e => this.radius(e)} inputRef={ ref => { this.inputRef = ref } } className={'radius-input location-text-input'}></FormControl><div className="add-margin-top-10 radius-second">{this.props.metricUnits === 'Meters' ? !window.I18n ? '' : window.I18n.t('customer_directories.filters.location_filter.kilometers_of') : !window.I18n ? '' : window.I18n.t('customer_directories.filters.location_filter.miles_of') }</div><GlgLoadingSpinner className="add-margin-right-5" show={this.state.locationIsLoading} width={25} color={'#5092fc'}></GlgLoadingSpinner>{!this.state.locationIsLoading && <FormControl type="text" value={this.state.location} onChange={e => this.location(e)} inputRef={ ref => { this.inputRef = ref } } className={'location-input location-text-input'}></FormControl>}<div className="go-button-container"><GlgButton text={ !window.I18n ? '' : window.I18n.t('customer_directories.filters.location_filter.go') } onClick={ this.handleChange } color="gray" size="normal" className={'go-button'} disabled={this.state.locationIsLoading}></GlgButton></div></div></div></div>}<div className={'pull-right hidden-directories-xs ' + clearFiltersClass}><ClearFilters onChange={ this.props.onChange }></ClearFilters></div></Col>
  }
}

LocationFilter.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  showLocationFilter: PropTypes.bool,
  currentLocation: PropTypes.string,
  metricUnits: PropTypes.string,
}

export default LocationFilter
